import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

import Layout from '@/layout';
import editorManage from './modules/editorManage'; // 简介管理
import systemManage from './modules/systemManage'; // 系统管理
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index'),
      },
    ],
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  {
    path: '/bind',
    component: () => import('@/views/login/bind'),
    hidden: true,
  },

  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true,
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true,
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true,
  },
  {
    path: '/',
    component: Layout,
    redirect: '/editor/article',
  },
  {
    path: '/account-infor/index',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/account-infor/index',
        component: () => import('@/views/account-infor/index'),
      },
    ],
  },
];

export const asyncRoutes = [
  editorManage,
  systemManage,
  { path: '*', redirect: '/404', hidden: true },
];

const createRouter = () =>
  new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();

  router.matcher = newRouter.matcher; // reset router
}

export default router;
